import { clone, map, zipObj } from 'ramda';
import { Action, actionsList } from '@dirootie-web/components-types';
import { ActionButtonProps, ButtonProps, ButtonTT } from "@components-common/buttons";

const createButtonDefaults = (kind: Action) => {
  const defaults: Partial<ButtonProps> = {
    kind,
    key: `cb_${kind}`,
    as: ButtonTT
  };
  return defaults;
}

export const button_defaults: {[key in Action]:Partial<ButtonProps>} = zipObj(
  actionsList,
  map((a: Action) => clone(createButtonDefaults(a)),actionsList)
);
